import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';

@Component({
  selector: 'app-move-job-match-step',
  templateUrl: './move-job-match-step.component.html',
  styleUrls: ['./move-job-match-step.component.css']
})
export class MoveJobMatchStepComponent implements OnInit {

  @ViewChild('moveJobMatchStepForm') moveJobMatchStepForm: NgForm;
  
  @Input() jobMatchId: any;
  @Input() moveType: any;
  @Input() candidateId: any;
  @Input() label: any;
  @Input() notifyUsers: any;
  @Input() meetingScheduleId: any;
  @Input() externalMeetingId: any;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();

  //variables
  copyNote: any;
  companyId: any;
  moveData: any;
  userId: any;
  moveTypeLabel: any = '';
  candidateJobMatch: any = {};
  externalNotesAction: any = {};
  saveLabel: String = 'Move';
  savingLabel: String = 'Moving..';
  savingFlag: boolean = false;
  labelLoadingFlag: boolean = true;

  constructor(
    private authService: AuthService,
    private jobMatchService: JobMatchService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.copyNote = false;
    //variables
    this.companyId = this.authService.getUserDetails().company.companyId;

    this.moveData = {
      jobMatchId: this.jobMatchId,
      companyId: this.companyId,
      notes: '',
      externalNote: ''
    };

    this.userId = this.authService.getUserDetails().id;

    this._setLabels();
    this._getCandidateJobMatchCardInfo(() => {
      this.labelLoadingFlag = false;
    });
  }

  _setLabels() {
    if (this.moveType == 'Forward' || this.moveType == 'Backward') {
      this.moveTypeLabel = this.label.split(" to ")[1];
      if (this.moveType == 'Forward') {
        // add default notes only for forward move.
        this.moveData.notes = 'Moving candidate to ' + this.moveTypeLabel;
      } else if (this.moveType == 'Backward') {
        this.saveLabel = 'Move Back';
        this.savingLabel = 'Moving Back..';
      }
    } else if (this.moveType == 'Skip') {
      this.moveTypeLabel = this.label;
      this.saveLabel = 'Skip';
      this.savingLabel = 'Skipping..';
    }
  }

  _getCandidateJobMatchCardInfo(successCallback) {
    this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
      angular.merge(this.candidateJobMatch, data);
      this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
      if (successCallback) {
        successCallback();
      }
    }, (error) => {
      console.log('candidate get error - ', error);
      // do nothing.
    }, undefined);
  }

  _massageCandidateJobMatchData(candidateJobMatch) {
    candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
    return candidateJobMatch;
  }

  moveJobMatchStep() {
    if (!this.moveJobMatchStepForm.invalid) {
      this.savingFlag = true;
      if (this.moveType == 'Forward' || this.moveType == 'Skip') {
        if (this.moveType == 'Skip') {
          this.moveData.isSkip = true;
        }
        if (this.notifyUsers) {
          this.moveData.forFeedBack = true;
        }
        this.moveData.meetingScheduleId = this.meetingScheduleId ? this.meetingScheduleId : null;
        this.moveData.externalMeetingId = this.externalMeetingId ? this.externalMeetingId : null;

        this.jobMatchService.moveStepForward(this.moveData, (data) => {
          this.savingFlag = false;
          if (this.saveCallback) {
            this.saveCallback.emit();
          }
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      } else if (this.moveType == 'Backward') {
        this.jobMatchService.moveStepBackward(this.moveData, (data) => {
          this.savingFlag = false;
          if (this.saveCallback) {
            this.saveCallback.emit();
          }
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
      }
    }
  }

  onInternalNoteChanged() {
    this.moveData.externalNote = this.moveData.notes;
  }

  onExternalNoteChange(event) {
    this.moveData.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  receiveFormalizedComment(event) {
    this.moveData.notes = event;
    this.onInternalNoteChanged();
  }

  onVoiceTranscript(transcript) {
    if (this.moveData.notes) {
      this.moveData.notes += ' ' + transcript;
    } else {
      this.moveData.notes = transcript;
    }
    this.onInternalNoteChanged();
  }

}
